import React from 'react'
import './GoodDealSeal.scss';

export default ( props ) =>
    <div className='GoodDealSeal' >
        { !props.noSeal && <div className="GoodDealSeal__toolTip">Alerta para grandes ofertas:<br />este pode ser um ótimo negócio!</div> }
    </div>

